// Translation: Turkish > Server
const server = Object.freeze({
	errorItems: {
		'err.2FA_already_enabled': 'İki faktörlü kimlik doğrulama zaten aktif.',
		'err.account_disabled': 'Bu hesap devre dışı bırakıldı.',
		'err.account_locked_temporary': 'Bu hesap geçici olarak kilitlendi.',
		'err.already_send': 'Lütfen yeni bir kod göndermeden önce bir süre bekleyin.',
		'err.already_verified': 'Bu hesap zaten doğrulandı.',
		'err.auth_service_down': 'Üzgünüz. Talebinizi şu anda işleme koyamıyoruz. Lütfen daha sonra tekrar deneyin.',
		'err.captcha_validation_failed': 'Kullanıcı kimlik doğrulaması başarısız oldu.',
		'err.code_sent_recently': 'Çok fazla sıfırlama isteği aldık. Lütfen daha sonra tekrar deneyin.',
		'err.email_already_exists': 'E-posta adresi zaten var.',
		'err.email_is_not_valid': 'E-posta adresi geçerli değil.',
		'err.email_not_exists': 'E-posta adresi bulunamadı.',
		'err.exists': 'Kullanıcı zaten üye.',
		'err.exist_email': 'E-posta adresi zaten var.',
		'err.invalid_code': 'Kod geçersiz.',
		'err.not_found': 'Bulunamadı.',
		'err.user_not_exists': 'Kullanıcı mevcut değil.',
		'err.wrong_old_password': 'Eski şifre yanlış',
		'err.wrong_username_or_password': 'Girdiğiniz kullanıcı adı veya şifre yanlış.',
		'err.wrong_verification_code': 'Doğrulama kodu yanlış.'
	}
})

// Export
export default server
